import React from "react";
import styles from "./Page01.module.scss";
import { useBlocks } from "@jelly/lesson";

interface Lesson0501Page01Props {
  header1Label: string;
  header2Label: string;
  header3Label: string;
  audioButtonLabel: string;
  imageUrl: string;
  audio1Url: string;
  audio2Url: string;
  audio3Url: string;
  audio4Url: string;
  audio5Url: string;
  audio6Url: string;
  audio7Url: string;
  audio8Url: string;
  audio9Url: string;
}

export const Lesson0501Page01: React.FC<Lesson0501Page01Props> = (props) => {
  const block = useBlocks();

  return (
    <div className={styles.pageWrapper}>
      <img src={props.imageUrl} />
      <table>
        <thead>
          <tr>
            <th>{props.header1Label}</th>
            <th>{props.header2Label}</th>
            <th>{props.header3Label}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>(0,0)</td>
            <td>
              <block.audioButton
                theme="secondary"
                shape="round"
                size="small"
                icon={"cis-media-play"}
                url={props.audio1Url}
                text={`${props.audioButtonLabel} 1`}
              />
            </td>
          </tr>
          <tr>
            <td>2</td>
            <td>(1,-1)</td>
            <td>
              <block.audioButton
                theme="secondary"
                shape="round"
                size="small"
                icon={"cis-media-play"}
                url={props.audio2Url}
                text={`${props.audioButtonLabel} 2`}
              />
            </td>
          </tr>
          <tr>
            <td>3</td>
            <td>(1,0)</td>
            <td>
              <block.audioButton
                theme="secondary"
                shape="round"
                size="small"
                icon={"cis-media-play"}
                url={props.audio3Url}
                text={`${props.audioButtonLabel} 3`}
              />
            </td>
          </tr>
          <tr>
            <td>4</td>
            <td>(1,1)</td>
            <td>
              <block.audioButton
                theme="secondary"
                shape="round"
                size="small"
                icon={"cis-media-play"}
                url={props.audio4Url}
                text={`${props.audioButtonLabel} 4`}
              />
            </td>
          </tr>
          <tr>
            <td>5</td>
            <td>(2,-2)</td>
            <td>
              <block.audioButton
                theme="secondary"
                shape="round"
                size="small"
                icon={"cis-media-play"}
                url={props.audio5Url}
                text={`${props.audioButtonLabel} 5`}
              />
            </td>
          </tr>
          <tr>
            <td>6</td>
            <td>(2,-1)</td>
            <td>
              <block.audioButton
                theme="secondary"
                shape="round"
                size="small"
                icon={"cis-media-play"}
                url={props.audio6Url}
                text={`${props.audioButtonLabel} 6`}
              />
            </td>
          </tr>
          <tr>
            <td>7</td>
            <td>(2,0)</td>
            <td>
              <block.audioButton
                theme="secondary"
                shape="round"
                size="small"
                icon={"cis-media-play"}
                url={props.audio7Url}
                text={`${props.audioButtonLabel} 7`}
              />
            </td>
          </tr>
          <tr>
            <td>8</td>
            <td>(2,1)</td>
            <td>
              <block.audioButton
                theme="secondary"
                shape="round"
                size="small"
                icon={"cis-media-play"}
                url={props.audio8Url}
                text={`${props.audioButtonLabel} 8`}
              />
            </td>
          </tr>
          <tr>
            <td>9</td>
            <td>(2,2)</td>
            <td>
              <block.audioButton
                theme="secondary"
                shape="round"
                size="small"
                icon={"cis-media-play"}
                url={props.audio9Url}
                text={`${props.audioButtonLabel} 9`}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
